import React, { useMemo } from "react";
import Head from "next/head";

import { ProductDetailsType } from "modules/product-details/types";

// ===================================================
type Props = { productDetails: ProductDetailsType; productImageLink?: string };
// ===================================================

const ProductOpenGrapphTags: React.FC<Props> = ({
  productDetails,
  productImageLink,
}) => {
  const titleAndDesc = useMemo(() => {
    const { product_name } = productDetails;
    return product_name ? product_name.toUpperCase() : "";
  }, [productDetails]);

  const availability = useMemo(() => {
    if (productDetails?.status?.code === 1) {
      return "in stock";
    }
    return "out of stock";
  }, [productDetails?.status?.code]);

  const amount = useMemo(() => {
    let newAmount = productDetails?.retail_price?.toString();

    if (isNaN(parseFloat(newAmount))) {
      // Meaning a not valid amount
      newAmount = "";
    }

    return newAmount;
  }, [productDetails?.retail_price]);

  return (
    <Head>
      <meta property="og:title" content={titleAndDesc} />
      <meta property="og:description" content={titleAndDesc} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content={productImageLink} />
      <meta property="og:image:alt" content={titleAndDesc} />
      <meta property="og:locale" content="en_PH" />
      <meta property="og:locale:alternate" content="en_PH" />
      <meta property="og:price:currency" content="PHP" />
      <meta property="og:price:amount" content={amount} />

      <meta property="product:brand" content={productDetails?.product_name} />
      <meta property="product:availability" content={availability} />
      <meta property="product:condition" content="new" />
      <meta property="product:price:amount" content={amount} />
      <meta property="product:price:currency" content="PHP" />
      <meta
        property="product:retailer_item_id"
        content={productDetails?.product_uuid}
      />
      <meta
        property="product:item_group_id"
        content={productDetails?.category}
      />

      <meta property="product:locale" content="en_PH" />
      <meta property="product:category" content="Electronics" />
      <meta property="product:gender" content="unisex" />

      <meta property="product:sale_price:amount" content={amount} />
      <meta property="product:sale_price:currency" content="PHP" />

      <meta property="product:sale_price_dates:start" content="2020-01-01" />
      <meta property="product:sale_price_dates:end" content="2123-01-31" />

      {/* Repeat for product:custom_label_[0-4] as needed */}
      {/* <meta property="material" content="Cotton" /> */}
      {/* <meta property="product:catalog_id" content="12345" /> */}
      {/* <meta property="product:mfr_part_no" content="XYZ123" /> */}
    </Head>
  );
};

export default ProductOpenGrapphTags;
